import React from 'react';

import { SelectInput} from '@sogei/react-web-components-catalog'
import { observer, inject } from "mobx-react";
import i18next from 'i18next';



@inject("rootStore")
@observer
class SelectTipoCCI extends React.Component {

  constructor(props) {
    super(props);
    this.tipologicaStore = props.rootStore.tipologicaStore;
  
  }

  componentDidMount() {
  
    
  }

 

  render() {
   
    const sTipoCancellazione = (props) => {
    const listaCCI = this.tipologicaStore.tipoCCI;
      this.values = props.values;
      //console.log("this.values: ", JSON.stringify(this.values));
    

      //console.log("props: ", JSON.stringify(props));
      return (
        
        props.tipoPratica === 'CI'  && !props.isFromElenchi ?
        <div className='row'>
            <div className='col-sm-12 col-md-10 col-xl-10'>
            <SelectInput
                        id="tipoCancellazione"
                        name="tipoCancellazione"
                        value={this.values.tipoCancellazione}
                        dimension="lg"
                        label={i18next.t("TIPO_CANCELLAZIONE")}
                        firstEmptyOption={true}
                        optionList={listaCCI}
                      
                        inputClass={[]}
                        labelClass={[]}
                        event={{
                        onChange:  props.onChange
                        }}

                        extraProps={{
                        
                        }}
                    />
            </div>
        </div>
        :null
      )

    }
    
    return (
        sTipoCancellazione(this.props)

    );
  }

}




//export default SceltaTipoInvio;

export {SelectTipoCCI}; 